// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__3d8V7","content":"GlobalSearch_content__3yn3Z"};